<template>
  <div
    :class="{
      container: true,
      'banner-visible': bannerVisible,
      'common-notice-visible': $route.meta.showCommonNotice
    }"
    id="app"
  >
    <div class="env-banner">Produktionsmiljö</div>
    <div class="common-notice" title="Ändringar som görs här påverkar alla stiftelser">
      <font-awesome-icon :icon="['fal', 'exclamation-triangle']" />
      Detta är ett gemensamt basregister
    </div>
    <template v-if="!$route.meta.hideNavigation">
      <top-navigation />
      <side-navigation />
    </template>
    <router-view />
    <div v-if="$store.getters.errorMessage !== null" class="crash-overlay">
      <div>
        <h1>{{ $store.getters.errorMessage }}</h1>
        <p>Var god ladda om sidan</p>
      </div>
    </div>
    <reAuthModal />
  </div>
</template>

<style src="@/assets/style.css"></style>

<script>
import Vue from 'vue'
import reAuthModal from '@/components/auth/reAuthModal'
import sideNavigation from '@/components/navigation/side.vue'
import topNavigation from '@/components/navigation/top.vue'

export default Vue.extend({
  name: 'app',
  methods: {},
  computed: {
    bannerVisible() {
      // Production environment doesn't have a node_env set
      return process.env.VUE_APP_ENV === 'production'
    }
  },
  components: { reAuthModal, sideNavigation, topNavigation }
})
</script>

<style lang="scss" scoped>
.crash-overlay {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 99990;
  background-color: rgba(0, 0, 0, 0.59);
  h1 {
    font-size: 30px;
  }
  & > div {
    color: white;
    background-color: #01086f;
    border-radius: 10px;
    padding: 1rem;
    margin: auto;
    width: 25rem;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.env-banner {
  display: none;
}

// Production banner to make it clear that this is live data
.banner-visible {
  .env-banner {
    display: block;
  }

  .env-banner {
    position: fixed;
    top: 0;
    left: 0;
    height: 2rem;
    width: 100%;
    z-index: 99999;
    background-color: #ff6c6c;
    color: white;
    font-size: 1rem;
    text-align: center;
    line-height: 2rem;
  }
}

// Common register banner to make it clear that this is a common register
.common-notice {
  display: none;
}

.common-notice-visible {
  .common-notice {
    display: block;
  }

  .common-notice {
    position: fixed;
    top: 0;
    left: 0;
    height: 2rem;
    width: 100%;
    z-index: 99999;
    background-color: #6ca7ff;
    color: white;
    font-size: 1rem;
    text-align: center;
    line-height: 2rem;
  }
}

// Banner offsets
.banner-visible,
.common-notice-visible {
  &.container {
    margin-top: 2rem;
  }

  ::v-deep .button-container,
  ::v-deep .message-container {
    margin-top: 2rem !important;
  }
  &#app {
    min-height: var(--app-viewport-height);
  }
  ::v-deep .main > div {
    max-height: var(--app-viewport-height);
  }
}

.banner-visible.common-notice-visible {
  &.container {
    margin-top: 4rem;
  }
  .common-notice {
    top: 2rem;
  }
  ::v-deep .button-container,
  ::v-deep .message-container {
    margin-top: 4rem !important;
  }
  &#app {
    min-height: var(--app-viewport-height);
  }
  ::v-deep .main > div {
    max-height: var(--app-viewport-height);
  }
}
</style>
